import { render, staticRenderFns } from "./lwfooter.vue?vue&type=template&id=1223400e&scoped=true&"
import script from "./lwfooter.vue?vue&type=script&lang=js&"
export * from "./lwfooter.vue?vue&type=script&lang=js&"
import style0 from "./lwfooter.vue?vue&type=style&index=0&id=1223400e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1223400e",
  null
  
)

export default component.exports